<template>
  <div>
    <div @click="submitSurveyResponse">submit response</div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import surveyAPI from "../../api/surveyAPI";

export default {
  name: "Survey",
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      test: (state) => state.survey.test,
    }),
  },
  data() {
    return {
      surveyID: "",

      survey: {
        dummycontent: "i came from the client",
        type: 1, // e.g. all-at-once like Google Forms or one-at-a-time like Typeform, etc
        header: {
          enabled: true,
          coverURL: "",
          title: "",
          description: "",
        },
        sections: [
          {
            title: "",
            questions: [
              {
                question: "",
                description: "",
                type: 1, // single-line-input, multi-line-input, single-select, multi-select
                required: false,
                options: [],
                answers: [],
              },
            ],
          },
        ],
      },
    };
  },
  created() {
    this.getSurvey();
  },
  methods: {
    async getSurvey() {
      this.surveyID = this.$route.params.surveyID;
    },
    doSomething(num) {
      alert(num);
    },
    async submitSurveyResponse() {
      const response = await surveyAPI.submitSurveyResponse(this.user._id, this.survey);
      console.log("SURVEY RESPONSE: ", response);
    },
  },
};
</script>

<style></style>
